/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Link, Spinner, Stack, Text } from '@mybridge/ui';
// import Link from 'next/link';

import { useContext, useEffect } from 'react';
import { getUserFullName } from 'v4/lib/commons';
import { DiskContext } from '../../context';
import { humanFileSize } from 'v4/components/utils';
import { MyDiskUsageProgress } from '../../disk-usage-progress';
import { TeamsContext } from 'v4/snippets/teams/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyDiskUsagePanel = () => {
  const { selectedMainDirType, selectedSharedDiskUser, } =
  useContext(DiskContext);
  const {
    isOrganizer,
    diskOrganizer,
    userProfileInfo,
    teamDetails,
    changeDiskSubscriberDisc,
    teamOrganizers,
    teamOrganizersFetching,
    teamDetailsFetching,
  } = useContext(TeamsContext);
  const { t } = useTranslator();
  return (
    <>
      <Stack width="100%" p={[3, 0]}>
       
        <MyDiskUsageProgress />

      {selectedMainDirType==='team-disk'&&(  <HStack flexWrap="wrap">
          <Text fontSize="sm" flexShrink={0} flex={1}>
            {t('myDisk.subscriber') || "Subscriber"} {getUserFullName(teamDetails?.disk_payer_details)}
          </Text>
          {teamOrganizers?.length >= 2 && userProfileInfo?.id === teamDetails?.disk_payer_details?.id ? (
            <Box>
              <Link
                onClick={(e) => changeDiskSubscriberDisc?.onOpen?.()}
                fontSize="sm"
                href="#"
              >
                {t('myDisk.changeSubscriber') || "Change subscriber"}
              </Link>
            </Box>
          ) : (
            teamOrganizersFetching || teamDetailsFetching ? <Spinner size="sm"/> : ""
          )}
        </HStack>)}
      </Stack>
    </>
  );
};
